export default {
  "root": "_root_e36wa_1",
  "list": "_list_e36wa_1",
  "inner": "_inner_e36wa_1",
  "listItem": "_listItem_e36wa_1",
  "button": "_button_e36wa_1",
  "buttonContent": "_buttonContent_e36wa_1",
  "icon": "_icon_e36wa_1",
  "radio": "_radio_e36wa_1",
  "--item-active": "_--item-active_e36wa_1",
  "selector": "_selector_e36wa_1",
  "--selector-hidden": "_--selector-hidden_e36wa_1",
  "--selector-animated": "_--selector-animated_e36wa_1",
  "control": "_control_e36wa_1",
  "control--active": "_control--active_e36wa_1",
  "control--next": "_control--next_e36wa_1",
  "control--prev": "_control--prev_e36wa_1",
  "panel": "_panel_e36wa_1",
  "--panel-hidden": "_--panel-hidden_e36wa_1",
  "--direction-row": "_--direction-row_e36wa_1",
  "--direction-column": "_--direction-column_e36wa_1",
  "item": "_item_e36wa_1",
  "--variant-borderless": "_--variant-borderless_e36wa_1",
  "--variant-pills": "_--variant-pills_e36wa_1",
  "--variant-pills-elevated": "_--variant-pills-elevated_e36wa_1",
  "--size-medium": "_--size-medium_e36wa_1",
  "--size-large": "_--size-large_e36wa_1",
  "--item-width-equal": "_--item-width-equal_e36wa_1",
  "--fade-end": "_--fade-end_e36wa_1",
  "--fade-start": "_--fade-start_e36wa_1"
};import "ni:sha-256;Z7fJy_CvBcFG3B60ANKYMu2EtCbk4jM7xiYoqA1RNx8";